module.exports = __webpack_public_path__ + "img/pre2-celular.0b3004e1.jpg";